import React, { useState, useEffect } from 'react';
import {
  Box,
  TextField,
  Typography,
  Container,
  Tabs,
  Tab,
  Card,
  CardContent,
  InputAdornment,
} from '@mui/material';
import {
  Search as SearchIcon,
  Apartment as ApartmentIcon,
  Restaurant as RestaurantIcon,
  Event as EventIcon,
  School as SchoolIcon,
  SportsEsports as GamingIcon,
} from '@mui/icons-material';
import { getLocationOn, Colors } from '../../../helpers/navigationHelpers';
import styles from './SearchScreen.module.css';

const SearchScreen = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState(0);
  const [locationOn, setLocationOn] = useState(false);

  useEffect(() => {
    setLocationOn(getLocationOn());
  }, []);

  const primaryColor = locationOn ? Colors.CUSTOM_YELLOW : Colors.PRIMARY;

  const categories = [
    { label: 'All', icon: <SearchIcon /> },
    { label: 'Apartments', icon: <ApartmentIcon /> },
    { label: 'Restaurants', icon: <RestaurantIcon /> },
    { label: 'Events', icon: <EventIcon /> },
    { label: 'Universities', icon: <SchoolIcon /> },
    { label: 'Gaming', icon: <GamingIcon /> },
  ];

  const handleCategoryChange = (event, newValue) => {
    setSelectedCategory(newValue);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  return (
    <Container maxWidth="lg" className={styles.container}>
      {/* Search Header */}
      <Box className={styles.searchHeader}>
        <Typography variant="h4" component="h1" gutterBottom>
          Search
        </Typography>
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Search for apartments, events, restaurants..."
          value={searchQuery}
          onChange={handleSearchChange}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: '50px',
              backgroundColor: 'white',
              '&.Mui-focused fieldset': {
                borderColor: primaryColor,
              },
            },
          }}
        />
      </Box>

      {/* Category Tabs */}
      <Box className={styles.categoriesSection}>
        <Tabs
          value={selectedCategory}
          onChange={handleCategoryChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            '& .MuiTabs-indicator': {
              backgroundColor: primaryColor,
            },
            '& .Mui-selected': {
              color: primaryColor + ' !important',
            },
          }}
        >
          {categories.map((category, index) => (
            <Tab
              key={index}
              icon={category.icon}
              label={category.label}
              iconPosition="start"
            />
          ))}
        </Tabs>
      </Box>

      {/* Search Results */}
      <Box className={styles.resultsSection}>
        <Card>
          <CardContent>
            <Box className={styles.emptyState}>
              <SearchIcon sx={{ fontSize: 64, color: '#ccc' }} />
              <Typography variant="h6" color="text.secondary" gutterBottom>
                {searchQuery ? 'No results found' : 'Start searching'}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {searchQuery
                  ? `No results for "${searchQuery}"`
                  : 'Search for apartments, events, restaurants, and more'}
              </Typography>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default SearchScreen;

















